// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_IdiomasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for GET /config/traducoes/idiomas. */
import type { Traducoes_IdiomaRow } from './Traducoes_IdiomaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Traducoes_IdiomasResponseDados {
idiomas: Traducoes_IdiomaRow[]
}

export type Traducoes_IdiomasResponse = ApiResponse<Traducoes_IdiomasResponseDados>;

registerResponseContract('Traducoes_IdiomasResponse', {
  idiomas: {
    type: 'array',
    required: true,
    items: {
      codigo: { type: 'string',  required: false },
      nome:   { type: 'string',  required: false },
      padrao: { type: 'boolean', required: false },
    },
  },
})
